var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('inventory-list',{attrs:{"partId":_vm.partId,"crfqLineId":_vm.reqLineId,"gridId":_vm.gridId,"isShowCreatePartInventory":""}})}
var staticRenderFns = []

export { render, staticRenderFns }